<script setup lang="ts">
import { onBeforeUnmount, ref, useTemplateRef } from 'vue';
import TwoFactorPopup from '@/components/Popups/TwoFactorPopup.vue';
import eventBus from '@/setup/eventBus';
import { useTypedStore } from '@/store';

const store = useTypedStore();

const continueAction = ref('');
const continueActionParams = ref<any>({});
const twoFactorPopupRef = useTemplateRef('twoFactorPopup');

const checkSensitiveAction = async (action: string, row: any) => {
  await store.dispatch('session/checkSession');

  const lockStatus = store.getters['session/significantActionsSeconds'] === 0 ? 'lock' : 'unlock';
  if (lockStatus !== 'lock') {
    // @ts-expect-error event теперь типизирован
    eventBus.$emit(action, row);
  } else {
    continueAction.value = action;
    continueActionParams.value = row;
    openTwoFactorPopup();
  }
};

const openTwoFactorPopup = () => {
  twoFactorPopupRef.value?.open();
};

onBeforeUnmount(() => {
  eventBus.$off('checkSensitiveAction', checkSensitiveAction);
});

eventBus.$on('checkSensitiveAction', checkSensitiveAction);
</script>

<template>
  <TwoFactorPopup
    ref="twoFactorPopup"
    :continue-action="continueAction"
    :continue-action-params="continueActionParams"
  />
</template>
